import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* getAuditReportResponse({ payload: { Data } }) {
    try {
        const response = yield call(addData, '/getAuditReport', Data);
        if (response.response.Status) {
            yield put(
                actions.getAuditReportSuccess(
                    response.response.Data
                )
            )
        } else {
            yield put(actions.getAuditReportFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getAuditReportFailed(error));
    }
}



export default function* rootSaga() {
    yield all([takeEvery(actions.GET_AUDIT_REPORT, getAuditReportResponse)]);
    
}